import UpdatePolicy from "./UpdatePolicy";
export default UpdatePolicy;
